/** What this organisation calls its tax registration and its taxes (ADR-0036). */
export interface TaxWords {
  registration: string;
  valueAdded: string;
  withholding: string;
}

/**
 * Puts an organisation's own names into a sentence. Screens are written with PAN, VAT and TDS, and
 * this swaps the whole words, so "Recoverable VAT" reads "Recoverable GST" where tax is called that.
 */
export function nameTaxes(text: string, names: TaxWords): string {
  return text.replace(/\b(PAN|VAT|TDS)\b/g, (word) =>
    word === "PAN" ? names.registration : word === "VAT" ? names.valueAdded : names.withholding,
  );
}
